<evsb-standard-modal-window [fullHeight]="true">
  <header>
    <evsb-modal-header
      [backLabel]="'modules.evsb.navigation.back' | translate"
      [backEnabled]="canGoBack"
      (back)="prev()"
    >
      {{ 'modules.evsb.chargingStation.title' | translate }}
    </evsb-modal-header>
  </header>

  <swiper-container
    id="swiper"
    class="lg:max-w-screen-xl mb-12"
    data-cy="swiper"
    appSwiper
    #swiper
    [config]="swiperConfig"
    class="w-full h-full"
    (swiperactiveindexchange)="slideChanged($event)"
  >
    <swiper-slide *ngFor="let item of model.items" >
      <evsb-slide-card
          [title]="item.title | translate"
          [step]="item.step"
          [src]="item.src"
          [text]="item.text | translate"
          class="block pt-16 px-8 md:px-16"
        ></evsb-slide-card>
    </swiper-slide>
  </swiper-container>

  <footer [@fadeInUp]>
    <evsb-modal-footer>
      <div class="w-full flex flex-col gap-5">
        <evsb-primary-button [fullWidth]="true" (click)="next()">
          {{ 'modules.evsb.chargingStation.intro.next' | translate }}
        </evsb-primary-button>
        <button class="text-primary font-bold text-sm" (click)="skip()">
          {{ 'modules.evsb.chargingStation.intro.skip' | translate }}
        </button>
      </div>
    </evsb-modal-footer>
  </footer>
</evsb-standard-modal-window>
